import { createSelector } from 'reselect'
import type { State } from 'shared/types/gallery/state'

export const designPersonalizationContextIdSelector = (state: State.GlobalState): string | undefined =>
  state.designPersonalization.designPersonalizationContextId

export const dpcsLoadingSelector = (state: State.GlobalState): boolean => state.designPersonalization.dpcsLoading

export const hasImageSelector = (state: State.GlobalState): boolean => !!state.designPersonalization.designPersonalizationWidgetHasImage

export const hasColorSelector = (state: State.GlobalState): boolean => !!state.designPersonalization.designPersonalizationWidgetHasColor

export const colorVariationDPCsSelector = (state: State.GlobalState): string[] | undefined => state.designPersonalization.colorVariationDPCs

// createSelector ensures a stable array reference when contextId/dpcs haven't changed,
// so upstream createSelector chains (e.g. designVariationsInputSelector) keep their cache hits.
// Sends [contextId, ...dpcs] when contextId is present (even with zero color DPCs), so DC
// receives a context-only payload for single-color personalization instead of nothing.
export const customColorVariationsSelector = createSelector(
  designPersonalizationContextIdSelector,
  colorVariationDPCsSelector,
  (contextId, dpcs): string[] | undefined => (contextId ? [contextId, ...(dpcs ?? [])] : dpcs?.length ? dpcs : undefined),
)
